<template>
<div class="chapter">
<div class="inner_page">
<h2 class="part-no" id="part01">WAY TO LEAD 1</h2>
<h2 class="part-title"><span class="p-bold">A LEADER’S PREPARATION</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?5fda83ec